/** Compares dot-separated numeric versions, treating missing components as 0. */
export default function isVersionAtLeast(version: string | null, minimum: string): boolean {
  if (!version) return false;

  const parts = version.split('.').map(Number);
  const minimumParts = minimum.split('.').map(Number);

  for (let i = 0; i < Math.max(parts.length, minimumParts.length); i++) {
    const difference = (parts[i] ?? 0) - (minimumParts[i] ?? 0);
    if (difference !== 0) return difference > 0;
  }

  return true;
}
